import "./HooverscompanypageVTwoStyles.scss";
import axios from "axios";
import $ from "jquery";
import { dataMasking } from "../DataMasking/DataMasking";
import { dnbComLog, getViewportIsMobile, isNotUndefined, LogSeverity, trackCompanyProfileGalleryClickEvents } from "../FunctionsCore";
import { galleryPaginationWrapper, getChildren, hideClassName } from "../GalleryPagination/GalleryPagination";
const getThumbStage = () => $(".thumb-stage");
const getThumbStageContent = () => $(".thumb-stage-content");
const hooverscompanypageVTwo = (hooverscompanypageVTwoParameter) => {
    const getDayOfWeek = (date) => {
        const dayOfWeek = new window.Date(date).getDay();
        return window.Number.isNaN(dayOfWeek) ? void 0 : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][dayOfWeek];
    };
    const collapseOpenHours = () => {
        const $openHoursButton = $("#open-hours-button");
        const $openHoursListItems = $(".open-hours-list-item");
        const dayOfWeek = getDayOfWeek(new window.Date());
        for (const openHoursListItem of $openHoursListItems) {
            if (openHoursListItem instanceof HTMLElement) {
                openHoursListItem.style.display = openHoursListItem.textContent.includes(dayOfWeek) ? "list-item" : "none";
            }
        }
        $openHoursButton.text("See all hours");
    };
    // TODO
    window["collapseOpenHours"] = collapseOpenHours;
    const onLoadVideoThumbnails = ($e) => {
        var _a, _b, _c, _d;
        const id = $e.children()[0].id;
        if (id.includes("vid")) {
            const $id = $(`#${id}`);
            const dataVideo = $id.attr("data-video");
            if (isNotUndefined(dataVideo)) {
                let dataSourceOrSource = "https://img.youtube.com/vi/undefined/maxresdefault.jpg";
                let videoId;
                if (dataVideo.includes("youtube.com") || dataVideo.includes("youtube-nocookie.com") || dataVideo.includes("youtu.be")) {
                    if (dataVideo.includes("/embed/")) {
                        videoId = (_a = dataVideo.split("?")[0].split("/embed/")[1]) === null || _a === void 0 ? void 0 : _a.slice(0, 11);
                    }
                    else if (dataVideo.includes("/watch?v=")) {
                        videoId = (_b = dataVideo.split("&")[0].split("/watch?v=")[1]) === null || _b === void 0 ? void 0 : _b.slice(0, 11);
                    }
                    else if (dataVideo.includes("/shorts/")) {
                        videoId = (_c = dataVideo.split("?")[0].split("/shorts/")[1]) === null || _c === void 0 ? void 0 : _c.slice(0, 11);
                    }
                    else if (dataVideo.includes("youtu.be")) {
                        videoId = (_d = dataVideo.split("?")[0].split("youtu.be/")[1]) === null || _d === void 0 ? void 0 : _d.slice(0, 11);
                    }
                    if (isNotUndefined(videoId)) {
                        dataSourceOrSource = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
                    }
                    else {
                        dnbComLog(LogSeverity.ERROR, "videoId is undefined or null, path:", dataVideo);
                    }
                }
                else if (dataVideo.includes("vimeo.com")) {
                    videoId = dataVideo.includes("/video/")
                        ? dataVideo.split("?")[0].split("/video/")[1]
                        : dataVideo.split("?")[0].split("/vimeo.com/")[1];
                    axios
                        .get(`https://vimeo.com/api/v2/video/${videoId}.json`)
                        .then((ax) => {
                        var _a, _b;
                        const thumbnailLargeUrl = (_b = (_a = ax.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.thumbnail_large;
                        if (isNotUndefined(thumbnailLargeUrl) && thumbnailLargeUrl !== null) {
                            dataSourceOrSource = thumbnailLargeUrl;
                        }
                        else {
                            dnbComLog(LogSeverity.ERROR, "thumbnailLarge is undefined or null, path:", dataVideo);
                        }
                    })
                        .catch((er) => dnbComLog(LogSeverity.ERROR, "Network request failed", er));
                }
                $id.attr("data-src", dataSourceOrSource);
                $id.attr("src", dataSourceOrSource);
            }
        }
    };
    const updateGalleryItems = () => {
        // Display gallery photos and videos if available
        if ($(".galleryList").length > 0) {
            $(".galleryList .profile-gallery-item").each(function () {
                onLoadVideoThumbnails($(this));
            });
            // Updating the results count after all the gallery items are loaded
            galleryPaginationWrapper.addGalleryPaginationCallback((ga) => {
                ga.updateResultsReturned();
                // Display up to six images on desktop (limit is defined in GalleryPagination)
                const numberOfImagesToDisplay = window.Math.min(ga.getResultsReturned(), ga.getGalleryPageRange());
                if (getViewportIsMobile()) {
                    // Load all the image in to image slider on mobile.
                    $(".galleryList .thumb-scroll .thumb-scroll-content .profile-gallery-item").removeClass(hideClassName);
                }
                else {
                    // TODO Is this already taken care of by GalleryPagination?
                    const $children = getChildren();
                    $children.addClass(hideClassName);
                    for (let i = 0; i < numberOfImagesToDisplay; i += 1) {
                        $children
                            .eq(i)
                            .removeClass(hideClassName);
                    }
                }
            });
        }
    };
    const updateThumbStage = () => {
        // Constructing thumb-stage on mobile
        if ($(".galleryList").length > 0) {
            const $galleryListProfileGalleryItem = $(".galleryList .profile-gallery-item");
            $(".gallery-count").text(`(${$galleryListProfileGalleryItem.length})`);
            $galleryListProfileGalleryItem.each(function () {
                onLoadVideoThumbnails($(this));
            });
            const $galleryListProfileGalleryItemFirstElement = $galleryListProfileGalleryItem.eq(0);
            const $children = $galleryListProfileGalleryItemFirstElement.children();
            const mobId = $children.attr("id");
            const mobSource = $children.attr("data-src");
            const mobSourceVid = mobId.includes("vid") ? $children.attr("data-video") : "";
            let stageContent = "";
            if (mobId.includes("img")) {
                stageContent = `<img aria-label="Gallery Image" alt="Gallery Image/Video" id="${mobId}" class="thumb-stage-content lazyload" data-src="${mobSource}">`;
            }
            if (mobId.includes("vid")) {
                const mobPlayButtonSource = $children.eq(1).attr("src");
                stageContent = `<img aria-label="Gallery Video" alt="Gallery Image/Video" id="${mobId}" class="thumb-stage-content lazyload" data-src="${mobSource}" data-video="${mobSourceVid}">\n<img aria-label="Play Button" alt="Play Button" class="gallery-play-btn-stage" src="${mobPlayButtonSource}">`;
            }
            const $thumbStage = getThumbStage();
            $thumbStage.html("");
            $thumbStage.append(stageContent);
            $children.addClass("selected");
        }
    };
    const openGalleryPopup = () => {
        $(".carousel-container").css("display", "block");
        $(".carousel-inner").removeClass(hideClassName);
        $(".carousel-overlay").css("display", "block");
        trackCompanyProfileGalleryClickEvents("galleryOpen");
    };
    const expandGalleryImage = (id, sourceImg, sourceVid, sourcePlayBtn) => {
        if (isNotUndefined(id)) {
            let element;
            let eventType;
            if (id.includes("img")) {
                element = `<img  alt='Gallery Image' id="${id}" src="${sourceImg}" class="carousel-content-item" data-src="${sourceImg}" />`;
                eventType = "photoView";
            }
            if (id.includes("vid")) {
                element = `<a id="${id}" href="${sourceVid}" target="_blank"><img  alt='Gallery Video' src="${sourceImg}" class="carousel-content-item" data-src="${sourceImg}" data-video="${sourceVid}" /><img aria-label="Play Button" alt="Play Button" class="gallery-play-btn" src="${sourcePlayBtn}"></a>`;
                eventType = "videoView";
            }
            if (isNotUndefined(element)) {
                $(".carousel-container .carousel-content").html(element);
                trackCompanyProfileGalleryClickEvents(eventType);
            }
        }
    };
    const toggleCarouselNavControls = (id) => {
        const index = $(`.galleryList .profile-gallery-item #${id}`)
            .parent()
            .index();
        const isFirstItem = index === 0;
        galleryPaginationWrapper.addGalleryPaginationCallback((ga) => {
            const resultsReturned = ga.getResultsReturned();
            const isLastItem = index === resultsReturned - 1;
            if (resultsReturned === 1) {
                $(".carousel-nav-arrow-left, .carousel-nav-arrow-right").addClass(hideClassName);
            }
            else {
                if (isFirstItem) {
                    $(".carousel-nav-arrow-left").addClass(hideClassName);
                    $(".carousel-nav-arrow-right").removeClass(hideClassName);
                }
                if (isLastItem) {
                    $(".carousel-nav-arrow-right").addClass(hideClassName);
                    $(".carousel-nav-arrow-left").removeClass(hideClassName);
                }
                if (!isFirstItem && !isLastItem) {
                    $(".carousel-nav-arrow-left, .carousel-nav-arrow-right").removeClass(hideClassName);
                }
            }
        });
    };
    const showGalleryItemCount = (id) => {
        galleryPaginationWrapper.addGalleryPaginationCallback((ga) => {
            const index = $(`.galleryList .profile-gallery-item #${id}`)
                .parent()
                .index();
            const indexPlusOne = index + 1;
            const resultsReturned = ga.getResultsReturned();
            const galleryCount = `${indexPlusOne} of ${resultsReturned}`;
            $(".carousel-item-count").text(galleryCount);
            if (getViewportIsMobile()) {
                $(".mob-carousel-item-count").text(galleryCount);
            }
        });
    };
    let expandOrCollapseOpenHoursExpanded = false;
    window["expandOrCollapseOpenHours"] = () => {
        if (expandOrCollapseOpenHoursExpanded) {
            collapseOpenHours();
        }
        else {
            const $openHoursButton = $("#open-hours-button");
            const $openHoursListItem = $(".open-hours-list-item");
            $openHoursButton.text("Show fewer hours");
            $openHoursListItem.css("display", "list-item");
        }
        expandOrCollapseOpenHoursExpanded = !expandOrCollapseOpenHoursExpanded;
    };
    // Updating the stage content to the current image in carousel view.
    const retainSelectedItem = (destinationId, playButtonSource) => {
        $(".profile-gallery-img.selected").removeClass("selected");
        const profileGalleryImgDestinationId = $(`.profile-gallery-img#${destinationId}`);
        profileGalleryImgDestinationId.addClass("selected");
        const $thumbStageContent = getThumbStageContent();
        $thumbStageContent.attr("id", destinationId);
        $thumbStageContent.attr("src", profileGalleryImgDestinationId.attr("src"));
        $thumbStageContent.attr("data-src", profileGalleryImgDestinationId.attr("src"));
        if (destinationId.includes("vid")) {
            const $thumbStage = getThumbStage();
            if ($thumbStage.children(".gallery-play-btn-stage").length === 0) {
                $thumbStage.append(`<img aria-label="Play Button" alt="Play Button" class="gallery-play-btn-stage" src="${playButtonSource}">`);
            }
        }
    };
    window["prevGalleryItem"] = () => {
        const id = $(".carousel-container .carousel-content").children().eq(0).attr("id");
        const $previous = $(`.galleryList .profile-gallery-item #${id}`).parent().prev().children().eq(0);
        const destinationId = $previous.attr("id");
        const destinationSourceImg = $previous.attr("data-src");
        const destinationSourceVid = destinationId.includes("vid") ? $previous.attr("data-video") : "";
        const playButtonSource = $(`.profile-gallery-img#${destinationId}`).next().attr("src");
        if (getViewportIsMobile()) {
            retainSelectedItem(destinationId, playButtonSource);
        }
        expandGalleryImage(destinationId, destinationSourceImg, destinationSourceVid, playButtonSource);
        toggleCarouselNavControls(destinationId);
        showGalleryItemCount(destinationId);
    };
    window["nextGalleryItem"] = () => {
        const id = $(".carousel-container .carousel-content").children().eq(0).attr("id");
        const $next = $(`.galleryList .profile-gallery-item #${id}`).parent().next().children().eq(0);
        const destinationId = $next.attr("id");
        const destinationSourceImg = $next.attr("data-src");
        const destinationSourceVid = destinationId.includes("vid") ? $next.attr("data-video") : "";
        const playButtonSource = $(`.profile-gallery-img#${destinationId}`).next().attr("src");
        if (getViewportIsMobile()) {
            retainSelectedItem(destinationId, playButtonSource);
        }
        expandGalleryImage(destinationId, destinationSourceImg, destinationSourceVid, playButtonSource);
        toggleCarouselNavControls(destinationId);
        showGalleryItemCount(destinationId);
    };
    $(window).on("resize", () => {
        updateGalleryItems();
        updateThumbStage();
    });
    $(() => {
        const $body = $("body");
        const $claimCompanyButton = $(".claim-company-button");
        $("#claim_company_international").on("click", () => {
            $body
                .css("overflow", "hidden")
                .prepend(`
<div class="claim-company-lightbox">
    <button aria-label="close" class="lightbox_close_button" type="button"></button>

    <p class="lightbox_body"></p>
</div>

<div class="dnb-bg"></div>
`);
            // TODO
            $(".lightbox_body").html(window["lightbox_body_text"]);
            $claimCompanyButton.attr("aria-expanded", "true");
            const removeClaimCompanyLightbox = () => {
                $(".dnb-bg").remove();
                $(".claim-company-lightbox").remove();
                $body.css("overflow", "");
                $claimCompanyButton.attr("aria-expanded", "false");
            };
            $(".lightbox_close_button").on("click", removeClaimCompanyLightbox);
            $(".dnb-bg").on("click", removeClaimCompanyLightbox);
        });
        // Need to display the current day's hours of operation, if it exists
        collapseOpenHours();
        updateGalleryItems();
        updateThumbStage();
        const carouselContainer = window.document.querySelectorAll(".carousel-container");
        const carouselContainerFirstElement = carouselContainer[0];
        if (isNotUndefined(carouselContainerFirstElement)) {
            carouselContainerFirstElement.addEventListener("click", (cl) => {
                const target = cl.target;
                const shouldExit = [...target.classList].includes("carousel-overlay") || target.parentElement.className === "close-button" || target.parentElement.className === "mob-close-button";
                if (shouldExit) {
                    $body.css("overflow", "");
                    $(".carousel-content").html("");
                    $(".carousel-container").css("display", "none");
                    $(".carousel-container .carousel-content").removeClass("show");
                }
            });
        }
        const $activePage = $(".breadcrumb ol li").last();
        const $previousPage = $activePage.prevAll().eq(1);
        const $previousPageA = $previousPage.find("a");
        const previousLink = $previousPageA.attr("href");
        const previousText = $previousPageA.text();
        $(".previous-button a").attr("aria-label", previousText).attr("href", previousLink);
        $(".accordion-trigger").on("click", function () {
            if (getViewportIsMobile()) {
                const $this = $(this);
                if ($this.next().hasClass("accordion-content-hide")) {
                    $this.attr("aria-expanded", "true");
                    $this.next().attr("aria-hidden", "false");
                    $this.next().removeClass("accordion-content-hide");
                }
                else {
                    $this.attr("aria-expanded", "false");
                    $this.next().attr("aria-hidden", "true");
                    $this.next().addClass("accordion-content-hide");
                }
            }
        });
        const $thumbStage = getThumbStage();
        $(".profile-gallery-item").on("click", (cl) => {
            const target = cl.target;
            const $target = $(target);
            const $profileGalleryItem = $target
                .parent()
                .add($target)
                .filter(".profile-gallery-item");
            const $profileGalleryImg = $profileGalleryItem.find(".profile-gallery-img");
            const id = $profileGalleryImg.attr("id");
            // TODO ???
            if (getViewportIsMobile()) {
                const $thumbStageContent = getThumbStageContent();
                $thumbStageContent.removeClass("lazyloaded");
                $(".profile-gallery-img").removeClass("selected");
                $thumbStage
                    .find(".gallery-play-btn-stage")
                    .remove();
                $thumbStageContent.attr("id", id);
                $thumbStageContent.attr("data-src", $profileGalleryImg.attr("src"));
                $thumbStageContent.attr("data-video", $profileGalleryImg.attr("data-video"));
                $thumbStageContent.addClass("lazyload");
                $profileGalleryImg.addClass("selected");
                if (id.includes("vid") && $thumbStage.children(".gallery-play-btn-stage").length === 0) {
                    const src = $profileGalleryImg
                        .next()
                        .attr("src");
                    $thumbStage.append($("<img>")
                        .attr("aria-label", "Play Button")
                        .attr("alt", "Play Button")
                        .addClass("gallery-play-btn-stage")
                        .attr("src", src));
                }
            }
            else {
                // TODO id
                $(".gallery-carousel").append($("#carousel-container"));
                $body.css("overflow-y", "hidden");
                const sourceImg = $profileGalleryImg.attr("data-src");
                const sourceVid = id.includes("vid") ? $profileGalleryImg.attr("data-video") : "";
                const sourcePlayBtn = id.includes("vid") ? $profileGalleryImg.next().attr("src") : "";
                openGalleryPopup();
                expandGalleryImage(id, sourceImg, sourceVid, sourcePlayBtn);
                toggleCarouselNavControls(id);
                showGalleryItemCount(id);
            }
        });
        $thumbStage.on("click", (cl) => {
            const target = cl.target;
            const $target = $(target);
            // TODO id
            $(".gallery-carousel").append($("#carousel-container"));
            $body.css("overflow-y", "hidden");
            const $thumbStageFromTarget = $target
                .parent()
                .add($target)
                .filter(".thumb-stage");
            const $thumbStageContent = $thumbStageFromTarget.find(".thumb-stage-content");
            const id = $thumbStageContent.attr("id");
            const sourceImg = $thumbStageContent.attr("data-src");
            const sourceVid = id.includes("vid") ? $thumbStageContent.attr("data-video") : "";
            const sourcePlayBtn = id.includes("vid") ? $thumbStageContent.next().attr("src") : "";
            openGalleryPopup();
            expandGalleryImage(id, sourceImg, sourceVid, sourcePlayBtn);
            toggleCarouselNavControls(id);
            showGalleryItemCount(id);
        });
        $(".icon-tooltip")
            .on("click", function () {
            const $tooltiptext = $(this).find("span");
            if (getViewportIsMobile() && !$tooltiptext.is(":visible")) {
                $tooltiptext.css("display", "block");
            }
        })
            .on("mouseover", function () {
            const $tooltiptext = $(this).find("span");
            $tooltiptext.addClass("is-visible");
        });
        $(".view-more").on("click", function (cl) {
            cl.preventDefault();
            const $this = $(this);
            const $collapse = $this.closest("#relatedIndustries").find(".more-info");
            if ($collapse.is(":visible")) {
                $this.attr("aria-label", "Show more industries");
                $this.html('Show more <span class="icon arrow-down"></span>');
                $this.addClass("viewMore");
                $this.removeClass("viewLess");
                $("html, body").animate({
                    "scrollTop": $(".industry_body").offset().top - 140,
                }, 2000);
            }
            else {
                $this.blur();
                $this.attr("aria-label", "View fewer industries");
                $this.html('Show fewer <span class="icon arrow-up"></span>');
                $this.addClass("viewLess");
                $this.removeClass("viewMore");
            }
            $collapse.toggleClass("open");
            $this.closest("#relatedIndustries").find(".more-info li:first a").focus();
        });
        dataMasking(hooverscompanypageVTwoParameter);
    });
};
export { hooverscompanypageVTwo };
